import { render } from "./ResourcePagination.vue?vue&type=template&id=65a9e72a"
import script from "./ResourcePagination.vue?vue&type=script&lang=js"
export * from "./ResourcePagination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourcePagination.vue"]])

export default __exports__